 <template>
  <div class="part-container">
    <!-- 头部 -->
    <div class="part-header">
      <div class="header-title">相关美图</div>
    </div>

    <!-- 内容区域 -->
    <div class="images-content">
      <!-- 图片网格 -->
      <div class="images-grid" :class="{ 'no-data': !displayImages || displayImages.length === 0 }">
        <!-- 有图片数据时显示图片 -->
        <template v-if="displayImages && displayImages.length > 0">
          <div
            v-for="(image, index) in gridImages"
            :key="index"
            class="image-item"
            @click="handleImageClick(image, index)"
          >
            <div class="image-wrapper">
              <img :src="image.coverOssKey" :alt="image.title" class="image" >
              <div class="image-overlay">
                <div class="image-name">{{ image.customName }}</div>
              </div>
            </div>
          </div>
          <div
            v-if="showAddPlaceholder"
            class="placeholder-item"
            @click="handleAddClick"
          >
            <div class="placeholder-wrapper">
              <span class="plus">+</span>
            </div>
          </div>
        </template>
        
        <!-- 无图片数据时显示整体占位符 -->
        <div v-else class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-pic.png" alt="暂无图片" class="no-data-image" />
          <p class="no-data-text">暂无图片内容</p>
        </div>
      </div>
    </div>

    <!-- 自定义 PC 图片预览弹窗（样式与视频弹窗一致） -->
    <div class="image-preview-cover" v-if="previewVisible">
      <div class="pop">
        <div class="pop-video">
          <img
            v-if="previewImage.ossKey"
            ref="previewImageEl"
            class="preview-image"
            :src="previewImage.ossKey"
            :alt="previewImage.customName || '图片预览'"
          />
          <!-- 底部信息与导航 -->
          <div class="caption-bar">
            <div class="caption-left">{{ previewImage.customName }}</div>
            <div class="caption-right">
              <button class="nav-btn prev" :disabled="disablePrev" @click.stop="showPrev" aria-label="上一张">‹</button>
              <span class="counter">{{ displayIndex }}/{{ totalInPagePadded }}</span>
              <button class="nav-btn next" :disabled="disableNext" @click.stop="showNext" aria-label="下一张">›</button>
            </div>
          </div>
        </div>
        <img
          class="error-icon"
          src="/assets/~/media/images/icon/close-white.png"
          alt="关闭"
          @click="handlePreviewClose"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailImages',
  props: {
    // 图片数据列表
    images: {
      type: Array,
      default: () => [],
    },
    // 行数：1 或 2
    rows: {
      type: Number,
      default: 1,
      validator: (value) => value === 1 || value === 2,
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1,
    },
    // 每页数量（父组件以 page-size 传入）
    pageSize: {
      type: Number,
      default: 100,
    },
    // 总图片数量
    totalImages: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: {
        ossKey: '',
        customName: '',
      },
      currentIndex: 0,
      gridLimit: 10,
    };
  },
  computed: {
    // 总页数
    totalPages() {
      return Math.ceil(this.totalImages / this.pageSize);
    },
    // 当前显示的图片
    displayImages() {
      return this.images;
    },
    // 网格内展示的图片（前 7 张）
    gridImages() {
      return (this.displayImages || []).slice(0, 7);
    },
    // 是否显示加号占位（第 8 格）
    showAddPlaceholder() {
      return (this.displayImages && this.displayImages.length) >= 8;
      // return true;
    },
    // 本页总数
    totalInPage() {
      return (this.displayImages && this.displayImages.length) || 0;
    },
    // 显示索引（两位数）
    displayIndex() {
      const idx = this.currentIndex + 1;
      return String(idx).padStart(2, '0');
    },
    // 本页总数（两位数）
    totalInPagePadded() {
      return String(this.totalInPage).padStart(2, '0');
    },
    // 禁用上一张
    disablePrev() {
      return this.currentIndex <= 0 || this.totalInPage <= 0;
    },
    // 禁用下一张
    disableNext() {
      return this.totalInPage <= 0 || this.currentIndex >= this.totalInPage - 1;
    },
  },
  methods: {
    // 处理分页变化
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
    // 处理图片点击
    handleImageClick(image, index) {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关美图-第'+ (index+1) + '张图片', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关美图-第'+ (index+1) + '张图片');


      this.currentIndex = index;
      this.previewImage = {
        ossKey: image.ossKey,
        customName: image.customName || '',
      };
      this.previewVisible = true;
      this.$emit('image-click', image);
    },
    // 点击占位：从第 8 张开始预览
    handleAddClick() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关美图-“+”查看更多', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关美图-“+”查看更多');

      if (!this.totalInPage || this.totalInPage < 8) return;
      this.currentIndex = 7; // 第 8 张的索引
      this.updatePreviewByIndex();
      this.previewVisible = true;
    },
    // 根据索引更新预览
    updatePreviewByIndex() {
      if (!this.totalInPage) return;
      const clamped = Math.max(0, Math.min(this.currentIndex, this.totalInPage - 1));
      this.currentIndex = clamped;
      const img = this.displayImages[clamped] || {};
      this.previewImage = {
        ossKey: img.ossKey || '',
        customName: img.customName || '',
      };
    },
    // 上一张
    showPrev() {
      if (!this.totalInPage || this.disablePrev) return;
      this.currentIndex = this.currentIndex - 1;
      this.updatePreviewByIndex();
    },
    // 下一张
    showNext() {
      if (!this.totalInPage || this.disableNext) return;
      this.currentIndex = this.currentIndex + 1;
      this.updatePreviewByIndex();
    },
    // 关闭预览
    handlePreviewClose() {
      this.previewVisible = false;
      this.previewImage = { ossKey: '', customName: '' };
      this.currentIndex = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style/part.css';
.images-content {
  // padding: calc(10 / 1920 * 100vw) 0;
  
}
/* 图片网格样式 */
.images-grid {
  border-radius: calc(12 / 1920 * 100vw);
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: calc(3 / 1920 * 100vw);
  margin-bottom: calc(10 / 1920 * 100vw);
  aspect-ratio: 807 / 323;
  align-items: stretch;
}

/* 无数据时的整体占位符样式 */
.images-grid.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(230, 232, 234, 1);
  border-radius: calc(12 / 1920 * 100vw);
  /* 使用与正常网格相同的宽高比 */
  width: 100%;
  aspect-ratio: 807 / 323; /* 保持原有比例 */
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.no-data-image {
  width: calc(66 / 1920 * 100vw);
  height: calc(48 / 1920 * 100vw);
  margin-bottom: calc(8 / 1920 * 100vw);
  opacity: 0.5;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(12 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}

.image-item {
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}
.image-item:hover {
  // transform: scale(1.02);
  z-index: 10;
}
.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

/* 占位块（第 8 个） */
.placeholder-item {
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.placeholder-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(230, 232, 234, 1);
  color: #06141F;
  flex: 1;
}

.plus {
  font-size: calc(30 / 1920 * 100vw);
  font-weight: 600;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: calc(12 / 1920 * 100vw);
  opacity: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  transition: opacity 0.3s ease;
}

.image-name {
  color: #fff;
  font-size: calc(14 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

/* 鼠标悬停时显示图片名称 */
.image-wrapper:hover .image-overlay {
  opacity: 1;
}
.image-wrapper:hover .image {
  transform: scale(1.05);
}

/* PC 自定义图片弹窗样式（与视频弹窗一致） */
.image-preview-cover {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;

  .pop {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .pop-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(1140 / 1080 * 100vh);
    height: calc(684 / 1080 * 100vh);
  }

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }

  .error-icon {
    position: absolute;
    top: calc(50vh - 342 / 1080 * 100vh - 0 / 1080 * 100vh);
    left: calc(50vw + 570 / 1080 * 100vh + 10 / 1080 * 100vh);
    width: calc(30 / 1080 * 100vh);
    height: calc(30 / 1080 * 100vh);
    cursor: pointer;
  }

  .caption-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(16 / 1080 * 100vh) 0;
    pointer-events: none;
  }

  .caption-left {
    color: #fff;
    font-size: calc(16 / 1080 * 100vh);
    font-family: 'FZLanTingHeiS-B-GB';
    line-height: 1.4;
    pointer-events: auto;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }

  .caption-right {
    display: flex;
    align-items: center;
    gap: calc(8 / 1080 * 100vh);
    pointer-events: auto;
  }

  .counter {
    color: rgba(255, 255, 255, 1);
    font-size: calc(14 / 1080 * 100vh);
    margin: 0 calc(6 / 1080 * 100vh);
  }

  .nav-btn {
    width: calc(40 / 1080 * 100vh);
    height: calc(40 / 1080 * 100vh);
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 1);
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
  }

  .nav-btn:hover {
    background-color: lightgrey;
  }

  .nav-btn:disabled {
    background-color: lightgrey;
    cursor: not-allowed;
  }
}
</style>
